<template>
  <ZigzagServiceLayout
    mainTitle="Facial Harmonization & Aesthetic Injectables"
    mainDescription="Rediscover your natural radiance. Our expert neurotoxin and dermal filler treatments are designed to smooth wrinkles, restore volume, and enhance your unique features for a balanced, youthful appearance."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'FacialHarmonizationContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'ANTI-AGING',
          title: 'Neurotoxins (Botox/Dysport)',
          subtitle: 'Smooth out fine lines and expression wrinkles.',
          paragraphs: [
            "Neurotoxins like Botox and Dysport offer a safe, fast, and effective way to temporarily smooth out dynamic wrinkles caused by repetitive facial movements.",
            "By relaxing the targeted muscles, these treatments soften crow's feet, frown lines, and forehead wrinkles, leaving you with a refreshed, naturally well-rested look."
          ],
          list: [
            "Quick, minimally invasive procedure",
            "Targets expression lines and wrinkles",
            "Results typically last 3 to 4 months",
            "Prevents the formation of deeper wrinkles"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/dsy8tUMNyIs',
            'https://www.youtube.com/embed/LM2IEIQ-mC8'
          ]
        },
        {
          label: 'VOLUME & CONTOUR',
          title: 'Dermal Fillers',
          subtitle: 'Restore lost volume and enhance facial contours.',
          paragraphs: [
            "As we age, our skin loses its natural elasticity and volume. Dermal fillers use hyaluronic acid to safely and beautifully plump the skin from beneath the surface.",
            "Whether you want to enhance your lips, define your cheekbones, or fill in deep folds around the mouth, fillers provide an immediate, natural-looking lift that brings balance to your face."
          ],
          list: [
            "Restores youthful volume to cheeks and lips",
            "Smooths out deep lines and facial folds",
            "Immediate, visible, and natural results",
            "Effects can last from 6 to 18 months"
          ],
          image: '/images/services/facial-harm.png'
        }
      ]
    };
  }
};
</script>
